import React from 'react';
import { PortalOverlay, Pane } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
import centroid from '@turf/centroid';
import { polygon } from '@turf/helpers';
import classnames from 'classnames';
import Pair from './Pair';
import S from './ZoneBeaconPairing.css';
import { jsx as _jsx } from "react/jsx-runtime";
export default class ZoneBeaconPairing extends React.Component {
  onChange = ({
    data,
    value,
    original
  }) => {
    this.setState({
      [data]: value
    });
    if (original && data === 'trackerId') {
      this.setState({
        tracker: original
      });
    }
    if (original && data === 'assetId') {
      this.setState({
        asset: original
      });
    }
  };
  onPair = async () => {
    const {
      asset,
      tracker
    } = this.state;
    const {
      actions
    } = this.props;
    let zone = asset?.data?.geoshape,
      center;
    if (zone) {
      try {
        zone = JSON.parse(zone);
        center = centroid(polygon(zone?.geometry?.coordinates));
        center = center?.geometry?.coordinates;
      } catch (ex) {
        console.error(ex);
      }
    }
    await GlobalState.dispatch(actions.itemActions(asset.id).createObj().grp('beacons').create({
      id: tracker.id
    }));
    if (center) {
      await GlobalState.dispatch(actions.itemActions(asset.id).child('beacons').itemActions(tracker.id).update({
        data: [{
          path: 'position',
          value: {
            lat: center[1],
            lon: center[0]
          }
        }]
      }));
    }
  };
  render() {
    const {
      actions,
      show,
      onClose,
      mobile
    } = this.props;
    return /*#__PURE__*/_jsx(PortalOverlay, {
      variant: "dialog",
      showBackground: true,
      escapeWillClose: false,
      clickWillClose: false,
      show: show,
      onClose: onClose,
      targetId: "fullScreen",
      animation: "slideFromBottom",
      position: mobile ? 'full' : 'center',
      children: /*#__PURE__*/_jsx(Pane, {
        variant: mobile ? 'pairingMobile' : 'pairing',
        className: classnames(mobile ? S.pairingContainerMobile : S.pairingContainer, S.pairing),
        children: /*#__PURE__*/_jsx(Pair, {
          onChange: this.onChange,
          actions: actions,
          ...this.state,
          titleVariant: "dialogTitle",
          networkId: process.env.BEACON_NETWORK_ID,
          onPair: this.onPair,
          onClose: onClose
        })
      })
    });
  }
}